<template>
  <div id="app">
    <header class="app-header">
      <router-link to="/list" class="logo">Invoice 发票系统</router-link>
      <nav>
        <router-link to="/list">发票列表</router-link>
        <router-link to="/create">新建发票</router-link>
      </nav>
    </header>
    <main class="app-main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background: #f5f7fa; }
#app { min-height: 100vh; }
.app-header { background: #2c3e50; color: #fff; padding: 0 24px; height: 56px; display: flex; align-items: center; justify-content: space-between; }
.app-header .logo { color: #fff; text-decoration: none; font-weight: bold; font-size: 18px; }
.app-header nav a { color: rgba(255,255,255,0.9); text-decoration: none; margin-left: 24px; }
.app-header nav a:hover, .app-header nav a.router-link-active { color: #fff; }
.app-main { padding: 0; }
</style>
